import { render, staticRenderFns } from "./ProlongationModal.vue?vue&type=template&id=2d2f1b48&scoped=true&"
import script from "./ProlongationModal.vue?vue&type=script&lang=js&"
export * from "./ProlongationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProlongationModal.vue?vue&type=style&index=0&id=2d2f1b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f1b48",
  null
  
)

export default component.exports